import ConfirmarExclusao from '@/global/guides/Dialog/ConfirmarExclusao'
import { useCompensacaoManualOutletContext } from '@/pages/CompensacaoManual.context'
import { compensacaoManual } from '@/service/api/endpoints/compensacao-manual'
import { TipoCompensacaoManual } from '@acme/core'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'

function ExcluirCompensacaoManual() {
    const { id } = useParams()
    const navigate = useNavigate()

    const { isLoading, mutate } = compensacaoManual.mutations.useDelete({
        invalidateQuery: true,
    })

    const data = useCompensacaoManualOutletContext().data.get(Number(id))

    const handleSubmit = () => {
        mutate(Number(id), {
            onSuccess: () => {
                toast.success('Compensação manual removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover compensação manual')
                }
            },
        })
    }

    return (
        <ConfirmarExclusao
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title="Tem certeza que deseja excluir a compensação manual?"
        >
            {data && (
                <div className="space-y-2">
                    <p>
                        <strong>Tipo:</strong>{' '}
                        {data.tipo === TipoCompensacaoManual.COMPENSAR
                            ? 'Compensar'
                            : 'Compensado'}
                    </p>
                    <p>
                        <strong>Data:</strong>{' '}
                        {dayjs(data.data).format('DD/MM/YYYY')}
                    </p>
                    <p>
                        <strong>Competência:</strong> {data.competencia}
                    </p>
                    {data.Destinos && data.Destinos.length > 0 && (
                        <p>
                            <strong>Destinos:</strong> {data.Destinos.length}{' '}
                            dia(s)
                        </p>
                    )}
                </div>
            )}
        </ConfirmarExclusao>
    )
}

export default ExcluirCompensacaoManual
